
import Vue from "vue";
import "codemirror/mode/javascript/javascript";
import AppExtraButtonEditProperties from "@/components/admin/ExtraButtonEditProperties.vue";
import { ExtraButton } from "@/models/extra-button";
import {ExtraButtonService} from "@/services/extra-button-service";

export default Vue.extend({
	data(){
		return {
			button: new ExtraButton(),
			ready: false,
			propertyEditorOpen: false,
		};
	},
	computed: {
		cmOptions():any{
			return {
				mode: "text/javascript"
			};
		},
	},
	methods: {
		goToSettings(){
			this.$router.push(`/settings`);
		},
		async save(){
			if (this.button.ID == 0){
				this.button = await ExtraButtonService.createButton(this.button);
			}else{
				this.button = await ExtraButtonService.editButton(this.button);
			}
			this.$wf.notify("Changes saved", "success", 3000, "check");
		},
		editProperties(){
			this.propertyEditorOpen = true;
		},
	},
	async created(){
		let buttonId = parseInt(this.$route.params.id || "0");
		if (buttonId != 0){
			this.button = await ExtraButtonService.getButton(buttonId);
		}
		this.ready = true;
	},
	components: {
		AppExtraButtonEditProperties
	}
});
